import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ObfuscatedEmail from '@/components/base/ObfuscatedEmail';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div></div>
        <div>
          <h4 className="text-white text-sm font-semibold uppercase tracking-widest mb-4">{t('footer_nav_title')}</h4>
          <ul className="flex flex-col gap-3">
            {[
              { labelKey: 'nav_home', path: '/' },
              { labelKey: 'nav_contact', path: '/contact' },
            ].map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="text-sm text-stone-400 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  {t(link.labelKey)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold uppercase tracking-widest mb-4">{t('footer_contact_title')}</h4>
          <ul className="flex flex-col gap-3 text-sm text-stone-400">
            <li className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-line text-green-400"></i></span>
              <ObfuscatedEmail className="hover:text-green-400 transition-colors duration-200" />
            </li>
            <li className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-line text-green-400"></i></span>
              <a href="tel:+16138000431" className="hover:text-green-400 transition-colors duration-200 cursor-pointer">+1 (613) 800-0431</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-stone-500">{t('footer_copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
